import { useRouteError } from 'react-router-dom';

export default function ErrorPage() {
  const error = useRouteError();
  console.error(error);

  return (
    <div className="error-page">
      <h1>Oeps!</h1>
      <p>Er is iets fout gegaan.</p>
      <p>
        <i>{error.statusText || error.message}</i>
      </p>
    </div>
  );
}
